import { adminSession, loyaltySession } from '../utils/session';
import { FETCH_CREDENTIALS } from '../utils/laravelClient';
import { API_BASE_URL } from '../config/env';

/**
 * Revoke the current token on the server (best-effort).
 * Uses httpOnly cookies in production; optional bearer in tests.
 */
async function postRevoke(path, bearerToken) {
  const base = API_BASE_URL.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  const headers = { Accept: 'application/json' };
  if (bearerToken) {
    headers.Authorization = `Bearer ${bearerToken}`;
  }

  try {
    await fetch(`${base}${normalizedPath}`, {
      method: 'POST',
      headers,
      credentials: FETCH_CREDENTIALS,
    });
  } catch {
    // Network failure — still clear local session below
  }
}

/** Blacklist staff JWT on the server (POST /api/auth/logout). */
export async function revokeStaffToken() {
  return postRevoke('/auth/logout', adminSession.getBearerToken());
}

/** Delete loyalty Sanctum token on the server (POST /api/loyalty/logout). */
export async function revokeLoyaltyToken() {
  return postRevoke('/loyalty/logout', loyaltySession.getBearerToken());
}
